import projectDiagram from '~icons/fa-solid/project-diagram';
import layerGroup from '~icons/fa-solid/layer-group';
import fileExport from '~icons/fa-solid/file-export';
import keyboard from '~icons/fa-solid/keyboard';
import plus from '~icons/fa-solid/plus';
import minus from '~icons/fa-solid/minus';
import fileSignature from '~icons/fa-solid/file-signature';
import book from '~icons/fa-solid/book';

export const faAliases = {
  'project-diagram': projectDiagram,
  'layer-group': layerGroup,
  'file-export': fileExport,
  keyboard: keyboard,
  plus: plus,
  minus: minus,
  'file-signature': fileSignature,
  book: book
};
